<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Отказ" class="btn btn-default" to="/moderate/section/list"><i class="fa fa-times"></i></router-link>
					<button type="button" data-toggle="tooltip" title="Запис" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-block">

				<f-input
					v-model="section.name" name="section_name"
					v-validate="'required'" :errors="errorBag.collect('category_name')"
					:cplaceholder="'(пример: Четене)'">
				</f-input>

				<f-textarea
					v-model="section.description" name="section_description"
					v-validate="''" :errors="errorBag.collect('category_parent')">
				</f-textarea>

				<div style="position: relative">
					<div style="position: absolute; width: 40px; height: 100%;" :style="{'background-color': section.color}" class="cat-badge"></div>
					<f-select style="margin-left: 50px;"
						v-model="section.color" name="section_color"
						v-validate="'required'" :errors="errorBag.collect('section_color')" :values="$config.lists.sectionColors" :allow-other="true">
					</f-select>
				</div>

				<f-select style="margin-left: 50px;"
					v-model="section.paid" name="section_paid"
					v-validate="'required'" :errors="errorBag.collect('section_paid')" :values="{'0': {text: 'Не'}, '1': {text: 'Да'}}">
				</f-select>

			</div> <!-- end card-block -->
		</div> <!-- end card -->
	</div>
</div>
</template>

<script>
module.exports = {
	data: function () {
		return {
			section: {},
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			if (!this.$route.params.id) {
				this.dataReady = true;
				this.section = {
					name: '',
					description: '',
					color: '',
					paid: ''
				};
				return;
			}

			this.$http.get('backend://section/' + this.$route.params.id).then((response) => {
				this.section = response.body;
				if (this.section.parent !== undefined) {
					this.section.parent = this.section.parent + '';
				}
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		onSubmit: function () {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://section/', this.section).then((response) => {
					this.$router.push('/moderate/section/list');
				}).catch(this.$http.toastCatcher);
			});
		}
	}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// SectionEdit.vue?ce9d576e